// Persisted per-org room offsets for "arrange mode": drag rooms to fit how you
// think about the org; the layout engine applies these after the default grid.

export interface RoomOffset {
  dx: number
  dy: number
}

const key = (orgId: string) => `glass-office.roomOffsets.${orgId}`

export function getRoomOffsets(orgId: string): Record<string, RoomOffset> {
  try {
    const raw = localStorage.getItem(key(orgId))
    if (!raw) return {}
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return {}
    const out: Record<string, RoomOffset> = {}
    for (const [id, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (v && typeof v === 'object') {
        const o = v as Record<string, unknown>
        const dx = Number(o.dx)
        const dy = Number(o.dy)
        if (Number.isFinite(dx) && Number.isFinite(dy)) out[id] = { dx, dy }
      }
    }
    return out
  } catch {
    return {}
  }
}

export function addRoomOffset(orgId: string, roomId: string, dx: number, dy: number): void {
  try {
    const all = getRoomOffsets(orgId)
    const prev = all[roomId] ?? { dx: 0, dy: 0 }
    all[roomId] = { dx: prev.dx + dx, dy: prev.dy + dy }
    localStorage.setItem(key(orgId), JSON.stringify(all))
  } catch {
    // Storage unavailable — arranging just won't persist.
  }
}

export function clearRoomOffsets(orgId: string): void {
  try {
    localStorage.removeItem(key(orgId))
  } catch {
    // ignore
  }
}

export function hasRoomOffsets(orgId: string): boolean {
  return Object.keys(getRoomOffsets(orgId)).length > 0
}
